import { useCallback, useMemo } from "react";

import { MemberToolbar } from "CrossFeatureComponents/MemberToolbar/MemberToolbar";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";
import { memberPortalKeys } from "MemberPortal/API/keys";

import { queryClient } from "Utilities/ReactQuery/queryClient";

import { useIsGivePage } from "../hooks/useIsPageMatch";

export default function MemberPortalToolbar() {
  const isGivePage = useIsGivePage();
  const {
    activeContentKey,
    verticallyCenterLogin,
    callbackAfterLogin,
    setCallbackAfterLogin,
  } = useMemberToolbarStore();

  const onAuthChange = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: memberPortalKeys.myNotes(),
    });

    // handy callback to run after login
    if (callbackAfterLogin) {
      callbackAfterLogin();
    }
    setCallbackAfterLogin(null);
  }, [callbackAfterLogin, setCallbackAfterLogin]);

  const contextInquiryText = isGivePage
    ? "I have a question about giving"
    : null;

  const loginVariant = isGivePage ? "mmg" : "login";

  // when logging in on the Member Portal, move toolbar to center of screen
  const bottomOffset = useMemo(() => {
    if (activeContentKey === contentKeys.login && verticallyCenterLogin) {
      return window.innerHeight * 0.5 - 100;
    }
    return 0;
  }, [activeContentKey, verticallyCenterLogin]);

  // 7/31/25 - Dev Note: the original Member toolbar on the MMG page passed in a `fetchLandingPageData` function
  // (from the useFetchLandingPageData hook in MMG) to the onAuthChange prop (assumedly refetching data when the
  // user logs in or out). Things seem to be working properly without that, so it has been removed for now.

  return (
    <MemberToolbar
      contextInquiryText={contextInquiryText}
      loginVariant={loginVariant}
      bottomOffset={bottomOffset}
      onAuthChange={onAuthChange}
    />
  );
}
